import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { WorkQueueCase } from '../../services/workQueue';
import { useMeta } from '../../hooks/useWorkQueue';
import { fetchPatientCard } from '../../services/patientCard';
import { ForceStatusModal } from './ForceStatusModal';

interface RetiredStepNoticeProps {
    workCase: WorkQueueCase;
    onForced: () => void;
}

export function RetiredStepNotice({ workCase: c, onForced }: RetiredStepNoticeProps) {
    const { data: meta } = useMeta();
    const { data: card } = useQuery({
        queryKey: ['patient-card', c.id],
        queryFn: () => fetchPatientCard(c.id)
    });
    const [forceOpen, setForceOpen] = useState(false);

    return (
        <div className="flex-1 flex flex-col items-center justify-center gap-4 px-8 text-center">
            <ExclamationTriangleIcon className="w-10 h-10 text-gray-300" />
            <span className="font-inter text-sm text-gray-700">
                This step is retired. Use Force status to move the case to its current step.
            </span>
            <button
                onClick={() => setForceOpen(true)}
                className="px-4 py-2 rounded-lg bg-gray-800 text-white text-xs font-bold hover:bg-gray-900 transition-colors"
            >
                Force status
            </button>
            {forceOpen && (
                <ForceStatusModal
                    workCase={c}
                    meta={meta}
                    practiceId={card?.practice?.id}
                    onClose={() => setForceOpen(false)}
                    onForced={onForced}
                />
            )}
        </div>
    );
}
